module.exports = __webpack_public_path__ + "img/4a.c3d1b48b.jpg";